module.exports = "<div class=\"zizHeader logo text-center\">\r\n<img src=\"assets/img/ziz.png\" class=\"logo-img\" (click)=\"redirectpage()\">\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/user-header-before-signup.component.html
// module id = 1078
// module chunks = 31